import { Component, OnDestroy, OnInit } from "@angular/core";
import { Observable } from "rxjs/Observable";

import { HeaderService } from "../../../../views/services/header.service";
import { LandingService } from "../../../../views/services/landing.service";
import { ConsultantsService } from "../../accmgr/services/consultants.service";
import { SearchData } from "../../common/models/search";
import { DownloadDocumentService } from "../../common/services/downloaddocument.service";
import { AppService } from "../../../../views/services/app.service";
import { User } from "../../../../views/services/user.model";

@Component({
  selector: "app-consultantlanding",
  templateUrl: "./consultantlanding.component.html"
})
export class ConsultantLandingComponent implements OnInit, OnDestroy {
  public user: User;
  public consultants: any;
  public consultantId: any;
  public consultantData: any = {};
  public count: any;
  public consultantName: any;
  public searchData: SearchData = {};
  public retainedData: SearchData = {};
  public testNames: any;
  public testDates: any;

  constructor(
    private analystsService: ConsultantsService,
    private appService: AppService,
    public landingSvc: LandingService,
    private downloadDocumentService: DownloadDocumentService
  ) {}

  ngOnInit() {
    this.consultantData = [];
    this.appService
      .getUserProfile()
      .then(userProfile => (this.user = userProfile));
    this.retainedData = this.analystsService.getSearchResult();
    this.searchData.testDateId = "";
    this.searchData.testNameId = "";
    if (this.retainedData !== undefined && this.retainedData !== null) {
      this.searchData = this.retainedData;
      this.testDates = [];
      if (this.searchData.testNameId) {
        Observable.forkJoin(
          this.landingSvc.getTestDatesByTest(this.searchData.testNameId)
        ).subscribe(([testDates]) => {
          this.testDates = testDates.body;
        });
      }
    }
    this.testDates = [];
    Observable.forkJoin(
      this.analystsService.getConsultants(),
      this.landingSvc.getTest()
    )
      .finally(() => {
        Observable.forkJoin(
          this.analystsService.getConsultantData(
            this.consultantId,
            this.searchData.testNameId,
            this.searchData.testDateId
          )
        ).subscribe(([resp]) => {
          this.consultantData = resp;
          this.count = this.consultantData.length;
        });
      })
      .subscribe(([resp, tests]) => {
        this.consultants = resp;
        this.testNames = tests;
        for (let i = 0; i < this.consultants.length; i++) {
          if (this.consultants[i].USER_NM === this.user.userName) {
            this.consultantId = this.consultants[i].CONSULTANT_ID;
            this.consultantName = this.consultants[i].USER_NM;
          }
        }
      });
  }

  downloadFile(event, item: any, fileName) {
    this.downloadDocumentService.downloadFile(fileName, item);
    event.stopPropagation();
    event.preventDefault();
  }

  sendStudentDetails(examinee: any) {
    const studentDetails = {
      personId: examinee.PERSON_ID,
      requestId: examinee.REQUEST_ID,
      consultantId: examinee.CONSULTANT_ID ? examinee.CONSULTANT_ID : "",
      taaPin: examinee.ACCOMMS_PIN ? examinee.ACCOMMS_PIN : "",
      firstNm: examinee.PNFIRSTNAME ? examinee.PNFIRSTNAME : "",
      lastNm: examinee.PNLASTNAME ? examinee.PNLASTNAME : ""
    };
    sessionStorage.setItem(
      "internalStudentDetails",
      JSON.stringify(studentDetails)
    );
    sessionStorage.setItem("userConsultantName", this.consultantName);
  }

  checkSearch() {
    this.analystsService.setSearchResult(null);
    this.consultantData = [];
    Observable.forkJoin(
      this.analystsService.getConsultantData(
        this.consultantId,
        this.searchData.testNameId,
        this.searchData.testDateId
      )
    ).subscribe(([resp]) => {
      this.consultantData = resp;
      this.count = this.consultantData.length;
    });
    this.analystsService.setSearchResult(this.searchData);
  }

  onSelectedDropDownValue() {
    this.testDates = [];
    Observable.forkJoin(
      this.landingSvc.getTestDatesByTest(this.searchData.testNameId)
    ).subscribe(([testDates]) => {
      this.testDates = testDates.body;
    });
  }

  clearForm() {
    this.analystsService.setSearchResult(null);
    this.ngOnInit();
  }

  ngOnDestroy() {}
}



// WEBPACK FOOTER //
// ./client/app/internal/internalconsultants/consultantlanding/consultantlanding.component.ts